import React from 'react';
import { Typography } from '@mui/material';
import { APP_NAME_FULL, APP_NAME_SHORT } from '../appMeta';

export function ProductMark() {
  return (
    <Typography
      variant="subtitle1"
      component="p"
      color="primary"
      fontWeight={600}
      textAlign="center"
      sx={{ mb: 1 }}
      title={APP_NAME_FULL}
    >
      {APP_NAME_SHORT}
    </Typography>
  );
}
